import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { Box, FormHelperText, Grid, Typography } from '@mui/material';
import Dialog from '../../../common/Dialog';
import InputText, { InputSelectMultiV2, InputSelectNative } from '../../../common/Form';
import PhotoUpload from '../../../common/PhotoUpload';


class Sessions extends Component {
    state = { 
        session_name: this.props.session ? this.props.session.session_name : "",
        session_desc: this.props.session ? this.props.session.session_desc : "",
        session_articles: [],
        session_articlesID: [],
        errors: {}
    }
    componentDidMount = () => {
        const { ARTICLES, session } = this.props;
        if( session ){           
            let articlesDisplay = []
            let articlesID = []
            
            if(!isEmpty(session.session_articles)){
                articlesID = session.session_articles.split(", ")
                articlesID.map( item => {
                    articlesDisplay.push({
                        value: item,
                        label: `${ARTICLES[item].article_name} - ${ARTICLES[item].article_brand}`,
                        disabled: false,
                    })
                })
            }
            
            this.setState({
                session_articles: articlesDisplay,
                session_articlesID: articlesID,
            })

        }
    }
    handleChange = (e) => {
        const { name, value} = e.target;

        this.setState({
            [name]: value
        })
    }
    handleChangeMulti = (option, field) => {
        console.log('====================================');
        console.log({option, field});
        console.log('====================================');
        if(option){
            let IDList = option.map( item => item.value)
            this.setState({                
                [field]: option,
                [`${field}ID`]: IDList,
                page: 0,
                // checkedItems :[]
            })
        } else {
            this.setState({
                [field]: {label: "", value: ""},
                [`${field}ID`]: [],
                page: 0,
                // checkedItems :[]
            })

        }
    }
    setPhotos = (name, list) => {
        console.log("[INFO] SETPHOTOS", name, list);
        
        this.setState({
            [name]:list
        })
    }
    validate = () => {
        let noError = true
        let errors = {} 
        let required = [
            "session_name",
            "session_desc"
        ]

        console.log('====================================');
        console.log({required});
        console.log('====================================');
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        return noError
    }
    
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            data.session_name = this.state.session_name
            data.session_desc = this.state.session_desc
            data.session_articles = this.state.session_articles
            data.session_articles = isEmpty(this.state.session_articles) ? "" : this.state.session_articlesID.join(", ")

            console.log('====================================');
            console.log("submit session", {data});
            console.log('====================================');
        
            await this.props.newSession(data)

            // // if NoErrors ...
            if(this.props.STATE.sessions.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.sessions.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    validateUpdate = () => {
        let noError = true
        let errors = {} 
        let required = [
            "session_name",
            "session_desc",
        ]
            
        console.log('====================================');
        console.log({required});
        console.log('====================================');
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        return noError
    }
    handleSubmitUpdate = async () => {

        if( this.validateUpdate() ){
            let data = Object.assign({}, this.props.session)
            data.session_name = this.state.session_name
            data.session_desc = this.state.session_desc
            data.session_articles = isEmpty(this.state.session_articles) ? "" : this.state.session_articlesID.join(", ")

            console.log('====================================');
            console.log("submit session", {data});
            console.log('====================================');
        
            await this.props.updateSession(data)
            
            // // if NoErrors ...
            if(this.props.STATE.sessions.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.sessions.error}`)
            } else { 
                this.props.notif("success", "la session a été modifiée")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { update, ARTICLES } = this.props;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                title={update ? "Modifier la session" :`Nouvelle session`}
                close={this.props.handleClose}
                submitAction={update ? this.handleSubmitUpdate : this.handleSubmit}
                appBar
                // maxWidth="md"
            >
                <Grid container >
                    <Grid item xs={12}>
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="session_name"
                            error={this.state.errors.session_name}
                            value={this.state.session_name}
                            name="session_name"
                            label="Intitulé"
                        />
                    </Grid>
                    
                    <Grid item xs={12}>
                        <InputText
                            onChange={this.handleChange}
                            multiline
                            rows={3}
                            id="session_desc"
                            error={this.state.errors.session_desc}
                            value={this.state.session_desc}
                            name="session_desc"
                            label="Description"
                        />
                    </Grid> 
                    
                    <Grid item xs={12}>
                        <InputSelectMultiV2
                            label="Articles"
                            id="session_articles"
                            options={Object.values(ARTICLES).map( item => ({
                                label: `${item.article_name} - ${item.article_brand}`,
                                value: item.article_id,
                                disabled: Array.isArray(this.state.session_articles) && !!this.state.session_articles.find(element => element.value === item.article_id)
                            }))}
                            value={this.state.session_articles}
                            onChange={(option) => this.handleChangeMulti(option, "session_articles")}
                            isMulti
                            withCheckBox
                        />
                    </Grid>
                </Grid>      
            </Dialog>
        );
    }
}

export default Sessions;